import React, { useEffect, useState } from 'react';
import { Table, Button, Modal, Form, Input, Space, message, Select, Card, Row, Col, Pagination } from 'antd';
import {PlusOutlined,EditOutlined,DeleteOutlined,LinkOutlined} from '@ant-design/icons';
import { SidebarLayout } from '../components/SidebarLayout';
import axios from 'axios';
import { Icons } from '../components/Icons';
import { useAuth } from '../contexts/AuthContext';
import QRDeviceScanner from '../components/QRDeviceScanner';

const { Option } = Select;

const api = `${process.env.REACT_APP_API_URL}/truck_traylers`;

const TruckTraylerForm = ({ visible, onCancel, onSubmit, initialValues, customers, types, selectedClient }) => {
  const [form] = Form.useForm();
  const { user } = useAuth();

  useEffect(() => {
    if (visible) {
      const values = { ...initialValues };
      form.setFieldsValue(values || {});
    } else{
      form.resetFields();
    }
  }, [visible, initialValues, selectedClient]);

  return (
    <Modal
      open={visible}
      title={initialValues ? 'Editar Carreta' : 'Nova Carreta'}
      onCancel={onCancel}
      onOk={() => {
        form.validateFields().then(values => {
          form.resetFields();
          onSubmit(values);
        });
      }}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="dsplate"
          label="Placa"
          rules={[
            { required: true, message: 'Placa é obrigatória' },
            { max: 8, message: 'Máximo de 8 caracteres' },
            { pattern: /^[A-Z0-9-]+$/, message: 'Apenas letras maiúsculas, números e hífen' }
          ]}
        >
          <Input
            maxLength={8}
            onChange={e => {
              const upper = e.target.value.toUpperCase();
              form.setFieldsValue({ dsplate: upper });
            }}
          />
        </Form.Item>

        <Form.Item
          name="cdtype"
          label="Tipo"
          rules={[]}
        >
          <Select
            showSearch
            placeholder="Selecione o tipo"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
            allowClear
          >
            {types.map(type => (
              <Select.Option key={type.id} value={type.id}>
                {type.dsname}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

      </Form>
    </Modal>
  );
};

const TruckTraylerDevicesModal = ({
  visible,
  onCancel,
  traylerId,
  devices,
  traylerDevices,
  deviceStatuses,
  onSave
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (visible) {
      form.setFieldsValue({
        position1: traylerDevices.find(d => d.nrposition === 1)?.iddevice,
        position2: traylerDevices.find(d => d.nrposition === 2)?.iddevice,
        position3: traylerDevices.find(d => d.nrposition === 3)?.iddevice,
        position4: traylerDevices.find(d => d.nrposition === 4)?.iddevice,
        position5: traylerDevices.find(d => d.nrposition === 5)?.iddevice,
        position6: traylerDevices.find(d => d.nrposition === 6)?.iddevice,
        position7: traylerDevices.find(d => d.nrposition === 7)?.iddevice,
        position8: traylerDevices.find(d => d.nrposition === 8)?.iddevice,
        position9: traylerDevices.find(d => d.nrposition === 9)?.iddevice,
        position10: traylerDevices.find(d => d.nrposition === 10)?.iddevice,
        position11: traylerDevices.find(d => d.nrposition === 11)?.iddevice,
        position12: traylerDevices.find(d => d.nrposition === 12)?.iddevice,        status1: devices.find(d => d.id === traylerDevices.find(td => td.nrposition === 1)?.iddevice)?.cddisplaystatus,
        status2: devices.find(d => d.id === traylerDevices.find(td => td.nrposition === 2)?.iddevice)?.cddisplaystatus,
        status3: devices.find(d => d.id === traylerDevices.find(td => td.nrposition === 3)?.iddevice)?.cddisplaystatus,
        status4: devices.find(d => d.id === traylerDevices.find(td => td.nrposition === 4)?.iddevice)?.cddisplaystatus,
        status5: devices.find(d => d.id === traylerDevices.find(td => td.nrposition === 5)?.iddevice)?.cddisplaystatus,
        status6: devices.find(d => d.id === traylerDevices.find(td => td.nrposition === 6)?.iddevice)?.cddisplaystatus,
        status7: devices.find(d => d.id === traylerDevices.find(td => td.nrposition === 7)?.iddevice)?.cddisplaystatus,
        status8: devices.find(d => d.id === traylerDevices.find(td => td.nrposition === 8)?.iddevice)?.cddisplaystatus,
        status9: devices.find(d => d.id === traylerDevices.find(td => td.nrposition === 9)?.iddevice)?.cddisplaystatus,
        status10: devices.find(d => d.id === traylerDevices.find(td => td.nrposition === 10)?.iddevice)?.cddisplaystatus,
        status11: devices.find(d => d.id === traylerDevices.find(td => td.nrposition === 11)?.iddevice)?.cddisplaystatus,
        status12: devices.find(d => d.id === traylerDevices.find(td => td.nrposition === 12)?.iddevice)?.cddisplaystatus,
      });
    }
  }, [visible, traylerDevices, devices]);  const handleDeviceChange = (position, value) => {
    if (!value) return;

    const currentValues = form.getFieldsValue();
    const positions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    
    positions.forEach(pos => {
      if (pos !== position && currentValues[`position${pos}`] === value) {
        form.setFieldsValue({ [`position${pos}`]: undefined });
      }
    });

    const device = devices.find(d => d.id === value);
    if (device) {
      form.setFieldsValue({ [`status${position}`]: device.cddisplaystatus });
    }
  };

  const handleSave = async () => {
    try {
      setLoading(true);      const values = await form.validateFields();
      const payload = {
        devices: [
          {nrposition: 1, iddevice: values.position1, cddisplaystatus: values.status1 === undefined ? null : values.status1},
          {nrposition: 2, iddevice: values.position2, cddisplaystatus: values.status2 === undefined ? null : values.status2},
          {nrposition: 3, iddevice: values.position3, cddisplaystatus: values.status3 === undefined ? null : values.status3},
          {nrposition: 4, iddevice: values.position4, cddisplaystatus: values.status4 === undefined ? null : values.status4},
          {nrposition: 5, iddevice: values.position5, cddisplaystatus: values.status5 === undefined ? null : values.status5},
          {nrposition: 6, iddevice: values.position6, cddisplaystatus: values.status6 === undefined ? null : values.status6},
          {nrposition: 7, iddevice: values.position7, cddisplaystatus: values.status7 === undefined ? null : values.status7},
          {nrposition: 8, iddevice: values.position8, cddisplaystatus: values.status8 === undefined ? null : values.status8},
          {nrposition: 9, iddevice: values.position9, cddisplaystatus: values.status9 === undefined ? null : values.status9},
          {nrposition: 10, iddevice: values.position10, cddisplaystatus: values.status10 === undefined ? null : values.status10},
          {nrposition: 11, iddevice: values.position11, cddisplaystatus: values.status11 === undefined ? null : values.status11},
          {nrposition: 12, iddevice: values.position12, cddisplaystatus: values.status12 === undefined ? null : values.status12}
        ]
      }

      await axios.post(`${process.env.REACT_APP_API_URL}/truck_trayler_devices/link_all/${traylerId}`, payload);

      message.success('Dispositivos vinculados com sucesso');
      onSave();
    } catch (error) {
      message.error('Erro ao vincular dispositivos');
    } finally {
      setLoading(false);
    }
  };  return (
    <Modal
      open={visible}
      title="Vincular Dispositivos às Posições"
      onCancel={onCancel}
      onOk={handleSave}
      confirmLoading={loading}
      width={800}
    >
      <Form form={form} layout="vertical">
        <Row gutter={[16, 0]}>
          <Col xs={24} sm={24} md={12} lg={12}>            <Row gutter={[4, 0]} style={{ marginBottom: 16 }}>
              <Col xs={14} sm={14} md={14} lg={14}>
                <Form.Item name="position1" label="Posição 1">
                  <Select
                    showSearch
                    allowClear
                    placeholder="Selecione um dispositivo"
                    onChange={(value) => handleDeviceChange(1, value)}
                    filterOption={(input, option) => {
                      const device = devices.find(d => d.id === option.value);
                      return device?.dsdeveui.toLowerCase().includes(input.toLowerCase());
                    }}
                    dropdownStyle={{ fontSize: 12 }}
                    style={{ fontSize: 12 }}
                  >
                    {devices.filter(d => d.cdtype === 2).map(d => (
                      <Option key={d.id} value={d.id}>
                        <span style={{ fontSize: 12 }}>{d.dsdeveui}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={2} sm={2} md={2} lg={2} style={{ display: 'flex', alignItems: 'end', paddingBottom: 24 }}>
                <QRDeviceScanner
                  devices={devices}
                  deviceType={2}
                  onDeviceFound={(device) => {
                    handleDeviceChange(1, device.id);
                    form.setFieldsValue({ position1: device.id });
                  }}
                  size="small"
                />
              </Col>
              <Col xs={8} sm={8} md={8} lg={8}>
                <Form.Item name="status1" label="Status">
                  <Select
                    allowClear
                    placeholder="Status"
                    style={{ fontSize: 12 }}
                  >
                    {deviceStatuses.map(status => (
                      <Option key={status.id} value={status.id}>
                        <span style={{ fontSize: 12 }}>{status.dsname}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>            <Row gutter={[4, 0]} style={{ marginBottom: 16 }}>
              <Col xs={14} sm={14} md={14} lg={14}>
                <Form.Item name="position3" label="Posição 3">
                  <Select
                    showSearch
                    allowClear
                    placeholder="Selecione um dispositivo"
                    onChange={(value) => handleDeviceChange(3, value)}
                    filterOption={(input, option) => {
                      const device = devices.find(d => d.id === option.value);
                      return device?.dsdeveui.toLowerCase().includes(input.toLowerCase());
                    }}
                    dropdownStyle={{ fontSize: 12 }}
                    style={{ fontSize: 12 }}
                  >
                    {devices.filter(d => d.cdtype === 2).map(d => (
                      <Option key={d.id} value={d.id}>
                        <span style={{ fontSize: 12 }}>{d.dsdeveui}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={2} sm={2} md={2} lg={2} style={{ display: 'flex', alignItems: 'end', paddingBottom: 24 }}>
                <QRDeviceScanner
                  devices={devices}
                  deviceType={2}
                  onDeviceFound={(device) => {
                    handleDeviceChange(3, device.id);
                    form.setFieldsValue({ position3: device.id });
                  }}
                  size="small"
                />
              </Col>
              <Col xs={8} sm={8} md={8} lg={8}>
                <Form.Item name="status3" label="Status">
                  <Select
                    allowClear
                    placeholder="Status"
                    style={{ fontSize: 12 }}
                  >
                    {deviceStatuses.map(status => (
                      <Option key={status.id} value={status.id}>
                        <span style={{ fontSize: 12 }}>{status.dsname}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>            <Row gutter={[4, 0]} style={{ marginBottom: 16 }}>
              <Col xs={14} sm={14} md={14} lg={14}>
                <Form.Item name="position5" label="Posição 5">
                  <Select
                    showSearch
                    allowClear
                    placeholder="Selecione um dispositivo"
                    onChange={(value) => handleDeviceChange(5, value)}
                    filterOption={(input, option) => {
                      const device = devices.find(d => d.id === option.value);
                      return device?.dsdeveui.toLowerCase().includes(input.toLowerCase());
                    }}
                    dropdownStyle={{ fontSize: 12 }}
                    style={{ fontSize: 12 }}
                  >
                    {devices.filter(d => d.cdtype === 2).map(d => (
                      <Option key={d.id} value={d.id}>
                        <span style={{ fontSize: 12 }}>{d.dsdeveui}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={2} sm={2} md={2} lg={2} style={{ display: 'flex', alignItems: 'end', paddingBottom: 24 }}>
                <QRDeviceScanner
                  devices={devices}
                  deviceType={2}
                  onDeviceFound={(device) => {
                    handleDeviceChange(5, device.id);
                    form.setFieldsValue({ position5: device.id });
                  }}
                  size="small"
                />
              </Col>
              <Col xs={8} sm={8} md={8} lg={8}>
                <Form.Item name="status5" label="Status">
                  <Select
                    allowClear
                    placeholder="Status"
                    style={{ fontSize: 12 }}
                  >
                    {deviceStatuses.map(status => (
                      <Option key={status.id} value={status.id}>
                        <span style={{ fontSize: 12 }}>{status.dsname}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>            <Row gutter={[4, 0]} style={{ marginBottom: 16 }}>
              <Col xs={14} sm={14} md={14} lg={14}>
                <Form.Item name="position7" label="Posição 7">
                  <Select
                    showSearch
                    allowClear
                    placeholder="Selecione um dispositivo"
                    onChange={(value) => handleDeviceChange(7, value)}
                    filterOption={(input, option) => {
                      const device = devices.find(d => d.id === option.value);
                      return device?.dsdeveui.toLowerCase().includes(input.toLowerCase());
                    }}
                    dropdownStyle={{ fontSize: 12 }}
                    style={{ fontSize: 12 }}
                  >
                    {devices.filter(d => d.cdtype === 2).map(d => (
                      <Option key={d.id} value={d.id}>
                        <span style={{ fontSize: 12 }}>{d.dsdeveui}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={2} sm={2} md={2} lg={2} style={{ display: 'flex', alignItems: 'end', paddingBottom: 24 }}>
                <QRDeviceScanner
                  devices={devices}
                  deviceType={2}
                  onDeviceFound={(device) => {
                    handleDeviceChange(7, device.id);
                    form.setFieldsValue({ position7: device.id });
                  }}
                  size="small"
                />
              </Col>
              <Col xs={8} sm={8} md={8} lg={8}>
                <Form.Item name="status7" label="Status">
                  <Select
                    allowClear
                    placeholder="Status"
                    style={{ fontSize: 12 }}
                  >
                    {deviceStatuses.map(status => (
                      <Option key={status.id} value={status.id}>
                        <span style={{ fontSize: 12 }}>{status.dsname}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>            <Row gutter={[4, 0]} style={{ marginBottom: 16 }}>
              <Col xs={14} sm={14} md={14} lg={14}>
                <Form.Item name="position9" label="Posição 9">
                  <Select
                    showSearch
                    allowClear
                    placeholder="Selecione um dispositivo"
                    onChange={(value) => handleDeviceChange(9, value)}
                    filterOption={(input, option) => {
                      const device = devices.find(d => d.id === option.value);
                      return device?.dsdeveui.toLowerCase().includes(input.toLowerCase());
                    }}
                    dropdownStyle={{ fontSize: 12 }}
                    style={{ fontSize: 12 }}
                  >
                    {devices.filter(d => d.cdtype === 2).map(d => (
                      <Option key={d.id} value={d.id}>
                        <span style={{ fontSize: 12 }}>{d.dsdeveui}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={2} sm={2} md={2} lg={2} style={{ display: 'flex', alignItems: 'end', paddingBottom: 24 }}>
                <QRDeviceScanner
                  devices={devices}
                  deviceType={2}
                  onDeviceFound={(device) => {
                    handleDeviceChange(9, device.id);
                    form.setFieldsValue({ position9: device.id });
                  }}
                  size="small"
                />
              </Col>
              <Col xs={8} sm={8} md={8} lg={8}>
                <Form.Item name="status9" label="Status">
                  <Select
                    allowClear
                    placeholder="Status"
                    style={{ fontSize: 12 }}
                  >
                    {deviceStatuses.map(status => (
                      <Option key={status.id} value={status.id}>
                        <span style={{ fontSize: 12 }}>{status.dsname}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>            <Row gutter={[4, 0]} style={{ marginBottom: 16 }}>
              <Col xs={14} sm={14} md={14} lg={14}>
                <Form.Item name="position11" label="Posição 11">
                  <Select
                    showSearch
                    allowClear
                    placeholder="Selecione um dispositivo"
                    onChange={(value) => handleDeviceChange(11, value)}
                    filterOption={(input, option) => {
                      const device = devices.find(d => d.id === option.value);
                      return device?.dsdeveui.toLowerCase().includes(input.toLowerCase());
                    }}
                    dropdownStyle={{ fontSize: 12 }}
                    style={{ fontSize: 12 }}
                  >
                    {devices.filter(d => d.cdtype === 2).map(d => (
                      <Option key={d.id} value={d.id}>
                        <span style={{ fontSize: 12 }}>{d.dsdeveui}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={2} sm={2} md={2} lg={2} style={{ display: 'flex', alignItems: 'end', paddingBottom: 24 }}>
                <QRDeviceScanner
                  devices={devices}
                  deviceType={2}
                  onDeviceFound={(device) => {
                    handleDeviceChange(11, device.id);
                    form.setFieldsValue({ position11: device.id });
                  }}
                  size="small"
                />
              </Col>
              <Col xs={8} sm={8} md={8} lg={8}>
                <Form.Item name="status11" label="Status">
                  <Select
                    allowClear
                    placeholder="Status"
                    style={{ fontSize: 12 }}
                  >
                    {deviceStatuses.map(status => (
                      <Option key={status.id} value={status.id}>
                        <span style={{ fontSize: 12 }}>{status.dsname}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Col>

          <Col xs={24} sm={24} md={12} lg={12}>            <Row gutter={[4, 0]} style={{ marginBottom: 16 }}>
              <Col xs={14} sm={14} md={14} lg={14}>
                <Form.Item name="position2" label="Posição 2">
                  <Select
                    showSearch
                    allowClear
                    placeholder="Selecione um dispositivo"
                    onChange={(value) => handleDeviceChange(2, value)}
                    filterOption={(input, option) => {
                      const device = devices.find(d => d.id === option.value);
                      return device?.dsdeveui.toLowerCase().includes(input.toLowerCase());
                    }}
                    dropdownStyle={{ fontSize: 12 }}
                    style={{ fontSize: 12 }}
                  >
                    {devices.filter(d => d.cdtype === 2).map(d => (
                      <Option key={d.id} value={d.id}>
                        <span style={{ fontSize: 12 }}>{d.dsdeveui}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={2} sm={2} md={2} lg={2} style={{ display: 'flex', alignItems: 'end', paddingBottom: 24 }}>
                <QRDeviceScanner
                  devices={devices}
                  deviceType={2}
                  onDeviceFound={(device) => {
                    handleDeviceChange(2, device.id);
                    form.setFieldsValue({ position2: device.id });
                  }}
                  size="small"
                />
              </Col>
              <Col xs={8} sm={8} md={8} lg={8}>
                <Form.Item name="status2" label="Status">
                  <Select
                    allowClear
                    placeholder="Status"
                    style={{ fontSize: 12 }}
                  >
                    {deviceStatuses.map(status => (
                      <Option key={status.id} value={status.id}>
                        <span style={{ fontSize: 12 }}>{status.dsname}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>            <Row gutter={[4, 0]} style={{ marginBottom: 16 }}>
              <Col xs={14} sm={14} md={14} lg={14}>
                <Form.Item name="position4" label="Posição 4">
                  <Select
                    showSearch
                    allowClear
                    placeholder="Selecione um dispositivo"
                    onChange={(value) => handleDeviceChange(4, value)}
                    filterOption={(input, option) => {
                      const device = devices.find(d => d.id === option.value);
                      return device?.dsdeveui.toLowerCase().includes(input.toLowerCase());
                    }}
                    dropdownStyle={{ fontSize: 12 }}
                    style={{ fontSize: 12 }}
                  >
                    {devices.filter(d => d.cdtype === 2).map(d => (
                      <Option key={d.id} value={d.id}>
                        <span style={{ fontSize: 12 }}>{d.dsdeveui}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={2} sm={2} md={2} lg={2} style={{ display: 'flex', alignItems: 'end', paddingBottom: 24 }}>
                <QRDeviceScanner
                  devices={devices}
                  deviceType={2}
                  onDeviceFound={(device) => {
                    handleDeviceChange(4, device.id);
                    form.setFieldsValue({ position4: device.id });
                  }}
                  size="small"
                />
              </Col>
              <Col xs={8} sm={8} md={8} lg={8}>
                <Form.Item name="status4" label="Status">
                  <Select
                    allowClear
                    placeholder="Status"
                    style={{ fontSize: 12 }}
                  >
                    {deviceStatuses.map(status => (
                      <Option key={status.id} value={status.id}>
                        <span style={{ fontSize: 12 }}>{status.dsname}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>            <Row gutter={[4, 0]} style={{ marginBottom: 16 }}>
              <Col xs={14} sm={14} md={14} lg={14}>
                <Form.Item name="position6" label="Posição 6">
                  <Select
                    showSearch
                    allowClear
                    placeholder="Selecione um dispositivo"
                    onChange={(value) => handleDeviceChange(6, value)}
                    filterOption={(input, option) => {
                      const device = devices.find(d => d.id === option.value);
                      return device?.dsdeveui.toLowerCase().includes(input.toLowerCase());
                    }}
                    dropdownStyle={{ fontSize: 12 }}
                    style={{ fontSize: 12 }}
                  >
                    {devices.filter(d => d.cdtype === 2).map(d => (
                      <Option key={d.id} value={d.id}>
                        <span style={{ fontSize: 12 }}>{d.dsdeveui}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={2} sm={2} md={2} lg={2} style={{ display: 'flex', alignItems: 'end', paddingBottom: 24 }}>
                <QRDeviceScanner
                  devices={devices}
                  deviceType={2}
                  onDeviceFound={(device) => {
                    handleDeviceChange(6, device.id);
                    form.setFieldsValue({ position6: device.id });
                  }}
                  size="small"
                />
              </Col>
              <Col xs={8} sm={8} md={8} lg={8}>
                <Form.Item name="status6" label="Status">
                  <Select
                    allowClear
                    placeholder="Status"
                    style={{ fontSize: 12 }}
                  >
                    {deviceStatuses.map(status => (
                      <Option key={status.id} value={status.id}>
                        <span style={{ fontSize: 12 }}>{status.dsname}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>            <Row gutter={[4, 0]} style={{ marginBottom: 16 }}>
              <Col xs={14} sm={14} md={14} lg={14}>
                <Form.Item name="position8" label="Posição 8">
                  <Select
                    showSearch
                    allowClear
                    placeholder="Selecione um dispositivo"
                    onChange={(value) => handleDeviceChange(8, value)}
                    filterOption={(input, option) => {
                      const device = devices.find(d => d.id === option.value);
                      return device?.dsdeveui.toLowerCase().includes(input.toLowerCase());
                    }}
                    dropdownStyle={{ fontSize: 12 }}
                    style={{ fontSize: 12 }}
                  >
                    {devices.filter(d => d.cdtype === 2).map(d => (
                      <Option key={d.id} value={d.id}>
                        <span style={{ fontSize: 12 }}>{d.dsdeveui}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={2} sm={2} md={2} lg={2} style={{ display: 'flex', alignItems: 'end', paddingBottom: 24 }}>
                <QRDeviceScanner
                  devices={devices}
                  deviceType={2}
                  onDeviceFound={(device) => {
                    handleDeviceChange(8, device.id);
                    form.setFieldsValue({ position8: device.id });
                  }}
                  size="small"
                />
              </Col>
              <Col xs={8} sm={8} md={8} lg={8}>
                <Form.Item name="status8" label="Status">
                  <Select
                    allowClear
                    placeholder="Status"
                    style={{ fontSize: 12 }}
                  >
                    {deviceStatuses.map(status => (
                      <Option key={status.id} value={status.id}>
                        <span style={{ fontSize: 12 }}>{status.dsname}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>            <Row gutter={[4, 0]} style={{ marginBottom: 16 }}>
              <Col xs={14} sm={14} md={14} lg={14}>
                <Form.Item name="position10" label="Posição 10">
                  <Select
                    showSearch
                    allowClear
                    placeholder="Selecione um dispositivo"
                    onChange={(value) => handleDeviceChange(10, value)}
                    filterOption={(input, option) => {
                      const device = devices.find(d => d.id === option.value);
                      return device?.dsdeveui.toLowerCase().includes(input.toLowerCase());
                    }}
                    dropdownStyle={{ fontSize: 12 }}
                    style={{ fontSize: 12 }}
                  >
                    {devices.filter(d => d.cdtype === 2).map(d => (
                      <Option key={d.id} value={d.id}>
                        <span style={{ fontSize: 12 }}>{d.dsdeveui}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={2} sm={2} md={2} lg={2} style={{ display: 'flex', alignItems: 'end', paddingBottom: 24 }}>
                <QRDeviceScanner
                  devices={devices}
                  deviceType={2}
                  onDeviceFound={(device) => {
                    handleDeviceChange(10, device.id);
                    form.setFieldsValue({ position10: device.id });
                  }}
                  size="small"
                />
              </Col>
              <Col xs={8} sm={8} md={8} lg={8}>
                <Form.Item name="status10" label="Status">
                  <Select
                    allowClear
                    placeholder="Status"
                    style={{ fontSize: 12 }}
                  >
                    {deviceStatuses.map(status => (
                      <Option key={status.id} value={status.id}>
                        <span style={{ fontSize: 12 }}>{status.dsname}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>            <Row gutter={[4, 0]} style={{ marginBottom: 16 }}>
              <Col xs={14} sm={14} md={14} lg={14}>
                <Form.Item name="position12" label="Posição 12">
                  <Select
                    showSearch
                    allowClear
                    placeholder="Selecione um dispositivo"
                    onChange={(value) => handleDeviceChange(12, value)}
                    filterOption={(input, option) => {
                      const device = devices.find(d => d.id === option.value);
                      return device?.dsdeveui.toLowerCase().includes(input.toLowerCase());
                    }}
                    dropdownStyle={{ fontSize: 12 }}
                    style={{ fontSize: 12 }}
                  >
                    {devices.filter(d => d.cdtype === 2).map(d => (
                      <Option key={d.id} value={d.id}>
                        <span style={{ fontSize: 12 }}>{d.dsdeveui}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={2} sm={2} md={2} lg={2} style={{ display: 'flex', alignItems: 'end', paddingBottom: 24 }}>
                <QRDeviceScanner
                  devices={devices}
                  deviceType={2}
                  onDeviceFound={(device) => {
                    handleDeviceChange(12, device.id);
                    form.setFieldsValue({ position12: device.id });
                  }}
                  size="small"
                />
              </Col>
              <Col xs={8} sm={8} md={8} lg={8}>
                <Form.Item name="status12" label="Status">
                  <Select
                    allowClear
                    placeholder="Status"
                    style={{ fontSize: 12 }}
                  >
                    {deviceStatuses.map(status => (
                      <Option key={status.id} value={status.id}>
                        <span style={{ fontSize: 12 }}>{status.dsname}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export const TruckTraylers = () => {  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [formVisible, setFormVisible] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [types, setTypes] = useState([]);
  const [devices, setDevices] = useState([]);
  const [deviceStatuses, setDeviceStatuses] = useState([]);
  const [devicesModalVisible, setDevicesModalVisible] = useState(false);
  const [selectedTrayler, setSelectedTrayler] = useState(null);
  const [traylerDevices, setTraylerDevices] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [typeFilter, setTypeFilter] = useState(null);
  const pageSize = 6;
  const [messageApi, contextHolder] = message.useMessage();

  const { user, selectedClient } = useAuth();
  const fetchItems = async () => {
    setLoading(true);
    try {
      if (selectedClient) {
        const [resItems, resCustomers, resTypes, resDevices] = await Promise.all([
          axios.get(`${api}?selectedClient=${selectedClient?.client?.id}`),
          axios.get(`${process.env.REACT_APP_API_URL}/customers`),
          axios.get(`${process.env.REACT_APP_API_URL}/truck_trayler_type`),
          axios.get(`${process.env.REACT_APP_API_URL}/devices?selectedClient=${selectedClient?.client?.id}`)
        ]);
        let filteredItems = resItems.data;

        
        setItems(filteredItems);
        setCustomers(resCustomers.data);
        setTypes(resTypes.data);
        setDevices(resDevices.data);
      }
    } catch {
      messageApi.error('Erro ao buscar Carretas ou metadados');
    }
    setLoading(false);
  };
  const fetchDeviceStatuses = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/display_status`);
      setDeviceStatuses(res.data);
    } catch (error) {
      console.error('Erro ao buscar status dos dispositivos:', error);
    }
  };
  useEffect(() => {
    fetchItems();
    fetchDeviceStatuses();
  }, [selectedClient]);

  const getCustomerName = id => {
    const customer = customers.find(c => c.id === id);
    return customer ? customer.dsname : id;
  };

  const getTypeName = id => {
    const type = types.find(t => t.id === id);
    return type ? type.dsname : id;
  };

  const handleCreate = async values => {
    try {
      
      values.idcustomer = selectedClient.client.id;
      
      await axios.post(api, values);
      messageApi.success('Carreta criado com sucesso');
      fetchItems();
    } catch (error) {
      var apiMsg = 'Erro ao criar Carreta';
      if (error.response?.status != 500) {
        apiMsg +=  ': ' + error.response?.data?.error || '!';
      }
      messageApi.error(apiMsg);
    }
    setFormVisible(false);
  };

  const handleUpdate = async values => {
    try {
      await axios.put(`${api}/${editingItem.id}`, values);
      messageApi.success('Carreta atualizado com sucesso');
      fetchItems();
    } catch (error) {
      var apiMsg = 'Erro ao atualizar Carreta';
      if (error.response?.status != 500) {
        apiMsg +=  ': ' + error.response?.data?.error || '!';
      }
      messageApi.error(apiMsg);
    }
    setEditingItem(null);
    setFormVisible(false);
  };

  const handleDelete = id => {
    Modal.confirm({
      title: 'Tem certeza que deseja remover esta carreta?',
      content: 'Esta ação não poderá ser desfeita.',
      okText: 'Sim, remover',
      okType: 'danger',
      cancelText: 'Cancelar',
      onOk: async () => {
        try {
          await axios.delete(`${api}/${id}`);
          messageApi.success('Carreta removida com sucesso');
          fetchItems();
        } catch (error) {
          var apiMsg = 'Erro ao remover Carreta';
          if (error.response?.status != 500) {
            apiMsg +=  ': ' + error.response?.data?.error || '!';
          }
          messageApi.error(apiMsg);
        }
      }
    });
  };

  const handleOpenDevicesModal = async (trayler) => {
    setSelectedTrayler(trayler);
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/truck_trayler_devices/trayler/${trayler.id}`);
      setTraylerDevices(res.data);
    } catch {
      messageApi.error('Erro ao buscar dispositivos da carreta');
    }
    setDevicesModalVisible(true);
  };

  const filteredItems = items.filter(trayler =>
    trayler.dsplate.toLowerCase().includes(searchText.toLowerCase()) ||
    getTypeName(trayler.cdtype).toLowerCase().includes(searchText.toLowerCase()) ||
    getCustomerName(trayler.idcustomer).toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <SidebarLayout>
      {contextHolder}
      <div style={{ padding: 24 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 12 }}>
          <h1 style={{ fontSize: 30}}>
            Carretas
          </h1>
          <div
            style={{
              minWidth: 200,
              width: '100%',
              maxWidth: 320,
              marginTop: 8,
              marginLeft: 'auto',
              ...(window.innerWidth <= 600
                ? { order: 2, marginTop: 12, marginLeft: 0 }
                : { order: 0, marginTop: 0 })
            }}
          >
            <Select
              allowClear
              placeholder="Filtrar por tipo"
              style={{ width: '100%' }}
              value={typeFilter}
              onChange={setTypeFilter}
            >
              {types.map(type => (
                <Select.Option key={type.id} value={type.id}>{type.dsname}</Select.Option>
              ))}
            </Select>
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => {
              setEditingItem(null);
              setFormVisible(true);
            }}
          >
            Novo
          </Button>
          <Input.Search
            placeholder="Buscar"
            allowClear
            onSearch={value => setSearchText(value)}
            onChange={e => setSearchText(e.target.value)}
            style={{ width: 180 }}
          />
        </div>

        <Row gutter={[42, 32]}>
          {filteredItems
            .filter(item => (typeFilter ? item.cdtype === typeFilter : true))
            .slice((currentPage - 1) * pageSize, currentPage * pageSize)
            .map(trayler => (
              <Col xs={24} sm={12} md={8} lg={8} key={trayler.id}>
                <Card
                  actions={[
                    <LinkOutlined key="link" onClick={() => handleOpenDevicesModal(trayler)} />,
                    <EditOutlined key="edit" onClick={() => { setEditingItem(trayler); setFormVisible(true); }} />,
                    <DeleteOutlined key="delete" style={{ color: 'red' }} onClick={() => handleDelete(trayler.id)} />
                  ]}
                  className='fade-in'
                  style={{
                    boxShadow: '0 4px 10px rgba(0,0,0,0.08)',
                    borderRadius: 16,
                    padding: 0,
                    border: '1px solid #f0f0f0',
                    minHeight: 80,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between'
                  }}
                  bodyStyle={{
                    padding: 24,
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%'
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
                    <img src={Icons.traylerBlack} alt="trayler" style={{ width: 36, height: 36, marginRight: 12, marginLeft: -5 }} />
                    <div>
                      <div style={{ fontWeight: 700, fontSize: 18, color: '#222' }}>{trayler.dsplate}</div>
                      <div style={{ color: '#888', fontSize: 13 }}>
                        {getTypeName(trayler.cdtype)}
                      </div>
                      
                    </div>
                  </div>

                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'grid', gridTemplateColumns: '120px 1fr', rowGap: 8 }}>
                      <div style={{ display: 'contents' }}>
                        <span style={{ fontWeight: 500 }}>
                          <i className='fa fa-id-card' style={{marginRight: 4}}></i> Placa:
                        </span>
                        <span style={{ color: '#333' }}>{trayler.dsplate}</span>
                      </div>
                      <div style={{ display: 'contents' }}>
                        <span style={{ fontWeight: 500 }}>
                          <i className='fa fa-tag' style={{marginRight: 7}}></i> Tipo:
                        </span>
                        <span style={{ color: '#333' }}>{getTypeName(trayler.cdtype)}</span>
                      </div>
                     
                    </div>
                  </div>
                  
                </Card>
              </Col>
            ))}
        </Row>

        <div style={{ marginTop: 24, display: 'flex', justifyContent: 'end' }}>
          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={filteredItems.length}
            onChange={page => setCurrentPage(page)}
            showSizeChanger={false}
          />
        </div>

        <TruckTraylerForm
          visible={formVisible}
          onCancel={() => setFormVisible(false)}
          onSubmit={editingItem ? handleUpdate : handleCreate}
          initialValues={editingItem}
          customers={customers}
          types={types}
        />        <TruckTraylerDevicesModal
          visible={devicesModalVisible}
          onCancel={() => setDevicesModalVisible(false)}
          traylerId={selectedTrayler?.id}
          devices={devices}
          traylerDevices={traylerDevices}
          deviceStatuses={deviceStatuses}
          onSave={() => {
            setDevicesModalVisible(false);
            fetchItems();
            fetchDeviceStatuses();
          }}
        />
      </div>
    </SidebarLayout>
  );
};
